export const vehicleFormDefaults = {
  vehicleLicensePlate: "",
  vin: "",
  vehicleMake: "",
  vehicleModel: "",
  vehicleYear: "",
  operationalHours: "",
  registrationNumber: "",
  lifecycleStatus: "",
  fuelType: "",
  fuelEfficiency: "",
  totalAvailablekm: "",
  capacity: "",
  color: "",
  chassisNumber: "",
  variant: "",
  wheels: "",
  transmissionType: "",
  country: "",
};

/** API stores ms in attributes.operationalDuration; form uses hours. */
export const getOperationalHoursFromAttributes = (attributes) => {
  const ms = Number(attributes && attributes.operationalDuration);
  return Number.isFinite(ms) && ms > 0 ? String(ms / (60 * 60 * 1000)) : "";
};

const numberOrDefault = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const buildVehicleDetailPayload = (form) => ({
  label: (form.name || "").trim(),
  model: form.vehicleModel || "",
  fuelType: Number(form.fuelType) || 0,
  fuelEfficiency: numberOrDefault(form.fuelEfficiency, 1),
  totalAvailablekm: numberOrDefault(form.totalAvailablekm, 200),
  ...(form.chassisNumber ? { chassisNumber: form.chassisNumber } : {}),
  attributes: {
    ...(form.registrationNumber
      ? { registrationNumber: form.registrationNumber }
      : {}),
    ...(form.vehicleMake ? { make: form.vehicleMake } : {}),
    ...(form.vehicleYear ? { year: form.vehicleYear } : {}),
    ...(form.color ? { color: form.color } : {}),
    ...(form.lifecycleStatus
      ? { lifecycleStatus: form.lifecycleStatus }
      : {}),
    ...(form.capacity ? { capacity: form.capacity } : {}),
    ...(form.variant ? { variant: form.variant } : {}),
    ...(form.wheels ? { wheels: form.wheels } : {}),
    ...(form.transmissionType
      ? { trasmissionType: form.transmissionType }
      : {}),
    ...(form.country ? { country: form.country } : {}),
  },
});

export const mergeVehicleDetailIntoForm = (form, detail) => {
  if (!detail) return { ...form };
  const attributes = detail.attributes || {};

  return {
    ...vehicleFormDefaults,
    ...form,
    vehicleMake: attributes.make || "",
    vehicleModel: detail.model || attributes.model || "",
    vehicleYear: attributes.year != null ? String(attributes.year) : "",
    registrationNumber: attributes.registrationNumber || "",
    lifecycleStatus: attributes.lifecycleStatus || "",
    fuelType: detail.fuelType ? String(detail.fuelType) : "",
    fuelEfficiency:
      detail.fuelEfficiency != null && Number(detail.fuelEfficiency) !== 0
        ? String(detail.fuelEfficiency)
        : "",
    totalAvailablekm:
      detail.totalAvailablekm != null && Number(detail.totalAvailablekm) !== 0
        ? String(detail.totalAvailablekm)
        : "",
    capacity: attributes.capacity != null ? String(attributes.capacity) : "",
    color: attributes.color || "",
    chassisNumber: detail.chassisNumber || attributes.chassisNumber || "",
    variant: attributes.variant || "",
    wheels: attributes.wheels != null ? String(attributes.wheels) : "",
    transmissionType:
      attributes.trasmissionType || attributes.transmissionType || "",
    country: attributes.country || "",
  };
};

export const buildDeviceAttributes = (form) => {
  const attributes = { ...(form.attributes || {}) };

  if (attributes.speedLimit) {
    attributes.speedLimit = Number(attributes.speedLimit) * 0.539957;
  }
  if (form.device && form.model) {
    attributes.port = parseInt(form.device, 10);
    attributes.protocol =
      typeof form.model === "object" ? form.model.protocol : form.model;
  }
  if (form.operationalHours) {
    attributes.operationalDuration =
      Number(form.operationalHours) * 60 * 60 * 1000;
  } else {
    delete attributes.operationalDuration;
  }

  return attributes;
};

export const buildWizardPayload = (form, parentId) => {
  const attributes = buildDeviceAttributes(form);

  return {
    device: {
      id: 0,
      name: (form.name || "").trim(),
      uniqueId: form.uniqueId || "",
      vehicleLicensePlate: form.vehicleLicensePlate || "",
      model:
        typeof form.model === "object"
          ? form.model.protocol || form.model.value || form.model.label
          : form.model,
      phone: form.phone || "",
      contact: form.contact || "",
      category: form.category || "",
      parentId: form.parentId || parentId || 0,
      expirationTime: form.expirationTime || "",
      disabled: Boolean(form.disabled),
      vin: form.vin || "",
      attributes,
    },
    vehicleDetail: buildVehicleDetailPayload(form),
  };
};
